import { render } from "./TheLogin.vue?vue&type=template&id=e5d443ae&lang=pug"
import script from "./TheLogin.vue?vue&type=script&lang=js"
export * from "./TheLogin.vue?vue&type=script&lang=js"

import exportComponent from "/builds/chiedocover/chiedohome.com/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__